/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  fetchEdit,
  REQUEST_EDIT_DATA,
  REQUEST_LOAD_DATA,
} from '@/modules/User';

import { Box } from 'UIKit/Grid';
import Panel from 'sama_global/components/Panel';
import { useSnackbarListener } from 'sama_global/utils/hooks/snackbar';
import { useLoadbar } from 'sama_global/utils/hooks/loadbar';
import Form from 'sama_global/components/Form';
import { required, validDate, universalPhoneNumber } from '@/utils/Validate';
import RenderDateField from 'sama_global/components/RenderInput/RenderDateField';
import Centrify from 'sama_global/components/Centrify';

const fields = [
  {
    name: 'name_en',
    locale: 'NAME',
    validate: [required],
  },
  {
    name: 'surname_en',
    locale: 'SURNAME',
    validate: [required],
  },
  {
    name: 'birthday',
    locale: 'DATEBIRTH',
    validate: [validDate],
    component: RenderDateField,
  },
  {
    name: 'phone',
    locale: 'PHONE',
    validate: [universalPhoneNumber],
  },
  {
    name: 'email',
    locale: 'EMAIL',
    disabled: true,
  },
];

const Edit = ({ saveProfile, requests, user }) => {
  const request = requests[REQUEST_EDIT_DATA];
  const requestUser = requests[REQUEST_LOAD_DATA];

  useSnackbarListener(request?.errorMessage);
  useSnackbarListener(request?.success ? 'SAVED' : '', 'success');
  useLoadbar(REQUEST_LOAD_DATA);

  // eslint-disable-next-line camelcase
  const { name_en, surname_en, birthday, phone, email } = user;

  const handleSubmit = formData => {
    saveProfile({ ...user, ...formData });
  };

  return (
    <Centrify>
      <Box py={5} w={1} style={{ maxWidth: '620px', margin: 'auto' }}>
        <Panel>
          {requestUser?.success && (
            <Form
              title="PROFILE_TITLE"
              fields={fields}
              initialValues={{
                name_en,
                surname_en,
                birthday,
                phone,
                email,
              }}
              form="profile_edit"
              onSubmit={handleSubmit}
              fit
            />
          )}
        </Panel>
      </Box>
    </Centrify>
  );
};

Edit.propTypes = {
  requests: PropTypes.object.isRequired,
  saveProfile: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  requests: state.requests,
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  saveProfile(formData) {
    dispatch(fetchEdit(formData));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Edit);
